import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-turns-new-form-dashboard',
  templateUrl: './turns-new-form-dashboard.component.html',
  styleUrls: ['./turns-new-form-dashboard.component.scss']
})
export class TurnsNewFormDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file-alt', 'turns-page.new form', '/turns/forms', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.forms', '/turns/forms'), new BRoute('turns-page.new form')]));
  }
}
